var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _rect4, _rect5, _path5, _path6, _path7, _path8, _rect6, _rect7, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImgPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "100%",
  viewBox: "0 0 714 784",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 714,
  height: 784,
  rx: 12,
  fill: "black",
  fillOpacity: 0.05
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 63,
  width: 658,
  height: 76,
  rx: 8,
  fill: "white",
  fillOpacity: 0.5
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 79,
  width: 37,
  height: 36,
  rx: 4,
  fill: "black",
  fillOpacity: 0.1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M553.5 79C555.709 79 557.5 80.7909 557.5 83V89C557.5 91.2091 555.709 93 553.5 93H398.5C396.291 93 394.5 91.2091 394.5 89V83C394.5 80.7909 396.291 79 398.5 79H553.5Z",
  fill: "black",
  fillOpacity: 0.1
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M644.5 95C646.709 95 648.5 96.7909 648.5 99V105C648.5 107.209 646.709 109 644.5 109H398.5C396.291 109 394.5 107.209 394.5 105V99C394.5 96.7909 396.291 95 398.5 95H644.5Z",
  fill: "black",
  fillOpacity: 0.1
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M216 103C218.209 103 220 104.791 220 107V119C220 121.209 218.209 123 216 123H97C94.7909 123 93 121.209 93 119V107C93 104.791 94.7909 103 97 103H216Z",
  fill: "black",
  fillOpacity: 0.1
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M322 79C324.209 79 326 80.7909 326 83V95C326 97.2091 324.209 99 322 99H97C94.7909 99 93 97.2091 93 95V83C93 80.7909 94.7909 79 97 79H322Z",
  fill: "black",
  fillOpacity: 0.1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 147,
  width: 658,
  height: 76,
  rx: 8,
  fill: "white",
  fillOpacity: 0.5
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 163,
  width: 37,
  height: 36,
  rx: 4,
  fill: "black",
  fillOpacity: 0.1
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M553.5 163C555.709 163 557.5 164.791 557.5 167V173C557.5 175.209 555.709 177 553.5 177H398.5C396.291 177 394.5 175.209 394.5 173V167C394.5 164.791 396.291 163 398.5 163H553.5Z",
  fill: "black",
  fillOpacity: 0.1
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M644.5 179C646.709 179 648.5 180.791 648.5 183V189C648.5 191.209 646.709 193 644.5 193H398.5C396.291 193 394.5 191.209 394.5 189V183C394.5 180.791 396.291 179 398.5 179H644.5Z",
  fill: "black",
  fillOpacity: 0.1
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M216 187C218.209 187 220 188.791 220 191V203C220 205.209 218.209 207 216 207H97C94.7909 207 93 205.209 93 203V191C93 188.791 94.7909 187 97 187H216Z",
  fill: "black",
  fillOpacity: 0.1
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M322 163C324.209 163 326 164.791 326 167V179C326 181.209 324.209 183 322 183H97C94.7909 183 93 181.209 93 179V167C93 164.791 94.7909 163 97 163H322Z",
  fill: "black",
  fillOpacity: 0.1
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 231,
  width: 658,
  height: 76,
  rx: 8,
  fill: "white",
  fillOpacity: 0.5
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 247,
  width: 37,
  height: 36,
  rx: 4,
  fill: "black",
  fillOpacity: 0.1
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M553.5 247C555.709 247 557.5 248.791 557.5 251V257C557.5 259.209 555.709 261 553.5 261H398.5C396.291 261 394.5 259.209 394.5 257V251C394.5 248.791 396.291 247 398.5 247H553.5Z",
  fill: "black",
  fillOpacity: 0.1
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M644.5 263C646.709 263 648.5 264.791 648.5 267V273C648.5 275.209 646.709 277 644.5 277H398.5C396.291 277 394.5 275.209 394.5 273V267C394.5 264.791 396.291 263 398.5 263H644.5Z",
  fill: "black",
  fillOpacity: 0.1
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M216 271C218.209 271 220 272.791 220 275V287C220 289.209 218.209 291 216 291H97C94.7909 291 93 289.209 93 287V275C93 272.791 94.7909 271 97 271H216Z",
  fill: "black",
  fillOpacity: 0.1
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M322 247C324.209 247 326 248.791 326 251V263C326 265.209 324.209 267 322 267H97C94.7909 267 93 265.209 93 263V251C93 248.791 94.7909 247 97 247H322Z",
  fill: "black",
  fillOpacity: 0.1
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M55 25C57.2091 25 59 26.7909 59 29V39C59 41.2091 57.2091 43 55 43H32C29.7909 43 28 41.2091 28 39V29C28 26.7909 29.7909 25 32 25H55Z",
  fill: "black",
  fillOpacity: 0.1
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M157 25C159.209 25 161 26.7909 161 29V39C161 41.2091 159.209 43 157 43H76C73.7909 43 72 41.2091 72 39V29C72 26.7909 73.7909 25 76 25H157Z",
  fill: "black",
  fillOpacity: 0.1
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M682 25C684.209 25 686 26.7909 686 29V39C686 41.2091 684.209 43 682 43H601C598.791 43 597 41.2091 597 39V29C597 26.7909 598.791 25 601 25H682Z",
  fill: "black",
  fillOpacity: 0.1
})));
export default SvgImgPlaceholder;